import { useCallback, useEffect, useRef, useState } from "react";
import { isAuthenticated } from "../../auth";
import { getCommercialCapabilities } from "../../pageInside/Rolle";
import { getRecentlyViewedProviders, getRecentlyViewedProviderProducts } from "../services/providerProductService";

// Seller Sourcing History is a SELLER feature: the effective role (RoleSwitchDropdown-aware) must be
// able to source from Providers -- Seller and the combined roles Associate -> Family; never a strict
// Provider, Royalty or User. The backend enforces the same rule (requireSellerOwnerOrAdmin).
export const canUseSellerSourcingHistory = (infoSource) => Boolean(getCommercialCapabilities(infoSource).canBrowseProviders);

const LOADERS = { providers: getRecentlyViewedProviders, products: getRecentlyViewedProviderProducts };

// { items, loading, error, reload, setItems } for "providers" | "products". Never fetches when
// `enabled` is false. A failure only sets `error` -- the host page keeps working.
export function useSellerSourcingHistory(kind, { enabled = true, limit } = {}) {
  const [state, setState] = useState({ items: [], loading: Boolean(enabled), error: "" });
  const seq = useRef(0);
  const reload = useCallback(() => {
    if (!enabled) { setState({ items: [], loading: false, error: "" }); return; }
    const id = ++seq.current;
    setState((s) => ({ ...s, loading: true, error: "" }));
    LOADERS[kind](isAuthenticated()?.token, { limit }).then((r) => {
      if (id !== seq.current) return; // a newer request superseded this one
      if (!r || r.error || r.success === false || !Array.isArray(r.items)) setState({ items: [], loading: false, error: r?.error || "error" });
      else setState({ items: r.items, loading: false, error: "" });
    });
  }, [kind, enabled, limit]);
  useEffect(() => { reload(); return () => { seq.current += 1; }; }, [reload]);
  const setItems = useCallback((updater) => setState((s) => ({ ...s, items: typeof updater === "function" ? updater(s.items) : updater })), []);
  return { ...state, reload, setItems };
}

// History product entries -> the catalogue card payload ProviderProductCard already renders.
export const historyProducts = (items) => items.map((i) => i.product).filter(Boolean);
